import cn from "classnames";
import React, { useState } from "react";
import Card from "../../../components/Card";
import styles from "./RWAVaults.module.sass";
import Row from "./Row";
import { rwaData } from "../../../utils/config";
import { FaClock } from "react-icons/fa";
import blog1Image from "../../../assets/images/cards/0-3.jpg";
import blog2Image from "../../../assets/images/cards/0-4.jpg";
import blog3Image from "../../../assets/images/cards/0-5.jpg";
import ArticleModal from "./ArticleModal";
import useConfig from "../../../customHooks/useConfig";
import { KIITESTNET_CHAIN_ID } from "../../../ethers/contracts";

const RWAVaults = () => {
    const { chainId } = useConfig();
    const [modalVisible, setModalVisible] = useState(false);
    const [modalContent, setModalContent] = useState({ title: "" });

    const handleCardClick = (title) => {
        setModalContent({ title });
        setModalVisible(true);
    };

    // Filter RWA data: if KiiTestnet, only show USDT RWA
    const filteredRwaData = chainId === KIITESTNET_CHAIN_ID
        ? rwaData.filter((x) => x.defaultToken === 'USDT')
        : rwaData;

    return (
        <>
            <Card
                className={cn(styles.card)}
                // title="RWA Vaults"
                classTitle="title-purple"
            >
                <div className={styles.wrapper}>
                    <div className={styles.table}>
                        <div className={cn(styles.row)}>
                            <div className={styles.col} style={{ display: "none" }}></div>
                            <div className={styles.col}>Yield Source</div>
                            <div className={styles.col}>Vault Capacity</div>
                            <div className={styles.col}>Fixed APY</div>
                            <div className={styles.col}>Your Position</div>
                            <div className={styles.col}>Actions</div>
                        </div>
                        {filteredRwaData.map((x, index) => {
                            return (
                                <Row
                                    item={x}
                                    key={`rwa_${index}`}
                                />
                            );
                        })}
                    </div>
                </div>
            </Card>
            <div className={styles.cardGrid}>
                <Card 
                    className={cn(styles.card)} 
                    onClick={() => handleCardClick("About Real World Assets")}
                >
                    <div className={styles.titleSection}>
                        <h3>About Real World Assets</h3>
                        <div className={styles.minsRead}><FaClock /><span>2 mins read</span></div>
                    </div>
                    <div 
                        className={styles.imageSection} 
                        style={{ backgroundImage: `url(${blog1Image})` }}
                    />
                </Card>
                <Card 
                    className={cn(styles.card)} 
                    onClick={() => handleCardClick("World Mobile Business Details")}
                >
                    <div className={styles.titleSection}>
                        <h3>World Mobile Business Details</h3>
                        <div className={styles.minsRead}><FaClock /> <span>1 min read</span></div>
                    </div>
                    <div 
                        className={styles.imageSection} 
                        style={{ backgroundImage: `url(${blog2Image})` }}
                    />
                </Card>
                <Card 
                    className={cn(styles.card)} 
                    onClick={() => handleCardClick("World Mobile Risk Considerations")}
                >
                    <div className={styles.titleSection}>
                        <h3>World Mobile Risk Considerations</h3>
                        <div className={styles.minsRead}><FaClock /> <span>5 mins read</span></div>
                    </div>
                    <div 
                        className={styles.imageSection} 
                        style={{ backgroundImage: `url(${blog3Image})` }}
                    />
                </Card>
            </div>
            <ArticleModal
                visible={modalVisible}
                onClose={() => setModalVisible(false)}
                title={modalContent.title}
            />
        </>
    );
};

export default RWAVaults;
